import { h } from "preact";
import { Col, Avatar, Card } from "antd";
import { Text } from "../text";

const { Meta } = Card;

interface IShowCard {
  labelHeader: string;
  iconTitle: any;
  color: string;
  count: number;
}

const ShowCard = ({ labelHeader, iconTitle, color, count }: IShowCard) => {
  return (
    <Col xs={24} sm={24} md={24} lg={12} xl={7} style={{ marginBottom: 16 }}>
      <Card style={{ borderRadius: "1rem" }}>
        {
          (
            <Meta
              avatar={
                (
                  <Avatar
                    size={{ xs: 64, sm: 64, md: 64, lg: 64, xl: 64, xxl: 64 }}
                    icon={iconTitle}
                    style={{ backgroundColor: color }}
                  />
                ) as React.ReactNode
              }
              title={
                (
                  <Text size="L" color="gray" text={labelHeader} />
                ) as React.ReactNode
              }
              description={
                (
                  <Text size="XL" color={color} bold text={count} />
                ) as React.ReactNode
              }
            />
          ) as React.ReactNode
        }
      </Card>
    </Col>
  );
};

export default ShowCard;
